// extracted by mini-css-extract-plugin
export var acitonButtons = "_m0-0";
export var additionalIcon = "_m0-f";
export var block = "_m0-1";
export var blockContent = "_m0-7";
export var blockDescription = "_m0-8";
export var blockIcon = "_m0-9";
export var blockTitle = "_m0-6";
export var border = "_m0-a";
export var center = "_m0-l";
export var edge = "_m0-b";
export var edgeLabel = "_m0-c";
export var edgePath = "_m0-d";
export var error = "_m0-e";
export var flowchart = "_m0-g";
export var flowchartContent = "_m0-h";
export var highlighted = "_m0-3";
export var hover = "_m0-4";
export var icon = "_m0-i";
export var left = "_m0-m";
export var navButton = "_m0-j";
export var navButtons = "_m0-k";
export var right = "_m0-n";
export var selected = "_m0-2";
export var small = "_m0-5";